export const mixpanelFocusProperties = ({ source }) => ({
    'Search bar location': source,
});
